export const MODAL_NAME = {
  FORGOT_PASSWORD: 'forgot-password',
};

export const EMAIL_RESPONSE_MESSAGE = {
  SUCCESS: 'success',
  NOT_SUCCESS: 'not-success',
  EMAIL_NOT_REGISTERED: 'email-not-registered',
};
